module.exports = __webpack_public_path__ + "img/FernseheulenAberHeimlich.0e1d2991.jpg";